<template>
	<div>
		<CList @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
			<template slot="header">
                <th :class="StyleTh+' text-center'">#</th>
                <th :class="StyleTh">Nombre</th>
                <th :class="StyleTh">Clave</th>
                <th :class="StyleTh">Número de Ejes</th>
                <th :class="StyleTh">Número de Llantas</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
			</template>

			<template slot="body">
				<tr v-for="(lista,index) in ListaArrayRows" :key="index">
                    <td class="text-center"><p :class="StyleTd">{{(index+1)}}</p></td>
					<td><h6 :class="StylePr">{{$limitCharacters(lista.Nombre,100)}}</h6></td>
                    <td><p :class="StyleTd">{{lista.Clave}}</p></td>
                    <td><p :class="StyleTd">{{lista.NumEjes}}</p></td>
                    <td><p :class="StyleTd">{{lista.NumLlantas}}</p></td>
                    
					<td class="align-middle text-end">
						<CBtnAccion :pShowBtnEdit="true" :pShowBtnDelete="true" :pIsModal="true" :pId="lista.IdConfigAuto" :pEmitSeccion="ConfigList.EmitSeccion" :segurity="segurity">
							<template slot="btnaccion">
                            </template>
						</CBtnAccion>
					</td>
				</tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="6"></CSinRegistros>
			</template>
		</CList>

		<CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<Form :poBtnSave="oBtnSave"></Form>
			</template>
		</CModal>
	</div>
</template>

<script>

import moment from 'moment';
import Form from '@/views/catalogos/cpConfigAutoTransporte/Form.vue';
import Configs from '@/helpers/VarConfig.js';
const EmitEjecuta = 'seccionCpConfigAutoTransporte';

export default {
    name: 'ListaCpConfigAutoTransporte',
    props: ['sFiltros','pOrigen'],
    components: {
        Form
    },
    data() {
        return {
            ConfigList:{
                Title: 'Configuración AutoTransporte',
                IsModal: true,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: true,
                TitleFirst: '',
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Formulario Configuración AutoTransporte",
                ModalNameId: 'ModalForm',
                EmitSeccion: EmitEjecuta,
                ModalSize:'lg'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta,
            },
            segurity: {},
            obj: {},
            ListaArrayRows: [],               
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("cpConfigAutoTransportes",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('cpConfigAutoTransportes/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        if(Origen){
            this.ConfigList.TitleFirst = Origen;
        }
        else{
            this.ConfigList.ShowTitleFirst = false;
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');
    },
    mounted()
    {
        this.Lista();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });
    }
}
</script>
